/* Carrozzeria Truck — Verifica se monta con targa/telaio (scheda prodotto, solo ricambi IVECO).
 * Portato dal widget di Specialista Daily (sd-verifica-targa.js).
 * Config via window.CT_VT (iniettata dallo snippet ct-verifica-targa):
 *   { workerUrl, productId, productHandle, productTitle, hsPortal, hsForm, hsRegion }
 * Regola d'oro: il "no" del catalogo NON e' affidabile -> non diciamo MAI "incompatibile";
 *   compatibile SOLO se il Worker lo conferma per quel telaio, altrimenti "da verificare"
 *   e la richiesta passa a uno specialista (form HubSpot "Verifica Adattabilita'").
 */
(function () {
  var CFG = window.CT_VT || {};
  var root = document.querySelector('.ctvt');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var KEY = 'ct_vehicle';           // { value, kind:'targa'|'telaio', descr }
  var lastValue = '';               // ultimo valore verificato (per il prefill del form)
  var lastOutcome = '';
  var WORKER = (CFG.workerUrl || '').replace(/\/$/, '');
  var HANDLE = (CFG.productHandle || '').toLowerCase();
  var GO_LABEL = 'Verifica compatibilità';

  var $ = function (s) { return root.querySelector(s); };
  var chip = $('.ctvt__chip'), chipName = $('.ctvt__chip-name');
  var form = $('.ctvt__form'), input = $('.ctvt__input'), goBtn = $('.ctvt__go'), hint = $('.ctvt__hint');
  var after = $('.ctvt__after'), okBox = $('.ctvt__ok'), warnBox = $('.ctvt__warn');
  var vehBox = $('.ctvt__veh'), vehName = $('.ctvt__veh b');
  var assist = $('.ctvt__assist'), atc = $('.ctvt__atc');

  /* ---------- util ---------- */
  function normPlate(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function isPlate(v) { return /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/.test(v); }
  function isVin(v) { return /^[A-HJ-NPR-Z0-9]{17}$/.test(v); }
  function badReason(np, mode) {
    if (!np) return 'empty';
    if (mode === 'telaio') return np.length < 17 ? 'telaio_short' : 'bad_telaio';
    if (/^[A-Z]{2}[0-9]{4,}[A-Z]?$/.test(np)) return 'old_plate';   // provincia + numeri = targa vecchia
    return 'bad_plate';
  }
  // Eventi per GTM/GA4: mai la targa o il telaio (dato personale), solo esito e prodotto.
  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: 'ct_verify_' + name, product_handle: HANDLE };
      for (var k in (data || {})) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) {}
  }
  function readSaved() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(value, kind, descr) {
    try { localStorage.setItem(KEY, JSON.stringify({ value: value, kind: kind, descr: descr })); } catch (e) {}
  }

  /* ---------- worker ---------- */
  function ask(value, kind) {
    var url = WORKER + '/api/verifica?' + (kind === 'telaio' ? 'vin=' : 'targa=') + encodeURIComponent(value) +
      '&pid=' + encodeURIComponent(CFG.productId || '');
    var ctrl = new AbortController(); var to = setTimeout(function () { ctrl.abort(); }, 6000);
    return fetch(url, { signal: ctrl.signal })
      .then(function (r) { clearTimeout(to); return r.json().then(function (j) { j._status = r.status; return j; }); })
      .catch(function () { return { _status: 0, down: true }; });
  }
  // esito: 'ok' (compatibile) | 'warn' (veicolo riconosciuto, pezzo da verificare)
  //        | 'need_vin' (targa su piu' telai) | 'unknown' (non riconosciuto / servizio giu')
  function outcomeOf(res) {
    if (res && res.need_vin) return 'need_vin';
    if (!res || res.down || res.need_manual || res.error || res._status >= 400) return 'unknown';
    return res.compatibile ? 'ok' : 'warn';
  }

  /* ---------- render ---------- */
  var MSGS = {
    old_plate:    ['Targa non in archivio ✋', 'Sembra una <b>targa vecchia</b> (lettere di provincia): quelle non sono nell\'archivio. Usa il <b>telaio</b> — 17 caratteri, dal libretto — col pulsante <b>Telaio</b> qui sopra.'],
    telaio_short: ['Telaio incompleto ✋', 'Il <b>telaio</b> ha <b>17 caratteri</b>: serve <b>completo</b>, non le ultime cifre. Lo trovi sul <b>libretto</b> (riga E) o inciso sul mezzo.'],
    bad_telaio:   ['Controlla il telaio ✋', 'Ricontrolla i <b>17 caratteri</b> del telaio sul libretto (riga E): niente spazi, niente lettere I, O, Q.'],
    bad_plate:    ['Controlla la targa ✋', 'Controlla la <b>targa</b>: formato <b>AB 123 CD</b>. Se è vecchia o non la ricordi, usa il <b>telaio</b> col pulsante sopra.'],
    empty:        ['Inserisci targa o telaio ✋', 'Scrivi la <b>targa</b> (AB 123 CD) oppure il <b>telaio</b> (17 caratteri) e premi Verifica.'],
    need_vin:     ['Serve il telaio ✋', 'Questa targa risulta su <b>più mezzi</b>: inserisci il <b>numero di telaio</b> (17 caratteri, riga E del libretto) col pulsante <b>Telaio</b> qui sopra.'],
    not_found:    ['Ci pensiamo noi ✋', 'Questo mezzo non risulta nel nostro archivio (o è troppo recente). Prova col <b>telaio</b>, oppure lascia i tuoi dati qui sotto: <b>ci pensiamo noi</b> a trovarti il pezzo esatto.']
  };
  var WARN_VEH = ['Ci pensiamo noi ✋', 'Per il tuo veicolo risultano <b>più codici possibili</b> per questo ricambio: serve la verifica di un nostro <b>Specialista Iveco</b> per darti il pezzo <b>esatto</b>. Lascia i tuoi dati qui sotto: ti contattiamo subito.'];

  // opts.form: apre subito il form dello specialista (verifica chiesta dal cliente);
  // sui ricontrolli automatici del veicolo salvato resta chiuso, dietro al link.
  function render(outcome, res, reason, opts) {
    opts = opts || {};
    after.classList.add('is-on');
    var compat = outcome === 'ok';
    // prodotto non disponibile: niente bottone carrello nel riquadro verde
    var nativo = document.querySelector('[data-ct-buynow]');
    if (atc) atc.style.display = (nativo && !nativo.disabled) ? '' : 'none';
    okBox.style.display = compat ? 'block' : 'none';
    warnBox.style.display = compat ? 'none' : 'block';
    var veh = res && res.vehicle;
    if (veh && veh.descr && outcome !== 'need_vin') {
      vehName.textContent = veh.descr;
      vehBox.style.display = 'flex';
    } else {
      vehBox.style.display = 'none';
    }
    if (!compat) {
      var m = (veh && veh.descr && outcome === 'warn') ? WARN_VEH
        : (MSGS[outcome === 'need_vin' ? 'need_vin' : reason] || ['Controlla e riprova ✋', 'Non siamo riusciti a riconoscere il veicolo. Controlla targa/telaio, oppure lascia i tuoi dati: <b>ci pensiamo noi</b>.']);
      $('.ctvt__warn-t').innerHTML = m[0];
      $('.ctvt__warn-msg').innerHTML = m[1];
      var soloFormato = reason && reason !== 'not_found';      // errore di battitura: niente form
      var apri = !!opts.form && !soloFormato && outcome !== 'need_vin';
      $('.ctvt__warn-more').style.display = (apri || soloFormato || outcome === 'need_vin') ? 'none' : 'block';
      assist.classList.toggle('is-on', apri);
      if (apri) { loadHsForm(); prefillHs(); }
    } else {
      assist.classList.remove('is-on');
    }
  }
  function showChip(descr) {
    chipName.textContent = descr || 'Iveco';
    chip.classList.add('is-on'); form.style.display = 'none';
  }
  function resetVehicle() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    chip.classList.remove('is-on'); form.style.display = '';
    after.classList.remove('is-on'); assist.classList.remove('is-on');
    if (input) { input.value = ''; try { input.focus(); } catch (e) {} }
    track('reset', {});
  }

  /* ---------- hubspot (form "Verifica Adattabilita' - Carrozzeria Truck") ---------- */
  function hsDoc() {
    // il form HubSpot puo' rendere in un iframe same-origin oppure direttamente nella pagina
    var ifr = root.querySelector('.ctvt__hsform iframe');
    try { if (ifr) return ifr.contentDocument || (ifr.contentWindow || {}).document; } catch (e) { return null; }
    return root.querySelector('.ctvt__hsform form') ? root.querySelector('.ctvt__hsform') : null;
  }
  function setField(el, val) {
    el.value = val;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function appendTicket(doc, name, add) {     // una sola volta: il prefill si ripete
    var el = doc.querySelector('[name="' + name + '"]');
    if (!el || el.dataset.ctCtx) return;
    el.dataset.ctCtx = '1';
    var base = (el.value || '').trim();
    setField(el, base ? (base + ' — ' + add) : add);
  }
  function prefillHs(tries) {
    tries = tries || 0;
    var done = false;
    try {
      var doc = hsDoc();
      if (doc) {
        var ta = doc.querySelector('textarea[name="targa"], input[name="targa"]');
        var sv = readSaved() || {};
        // sempre cio' che il cliente ha scritto ORA nel box (non un valore vecchio memorizzato)
        var v = (input && input.value && input.value.trim()) || lastValue || sv.value || '';
        if (ta && v) setField(ta, v);
        // contesto nel ticket: l'operatore vede subito mezzo, esito e prodotto
        var out = { ok: 'COMPATIBILE', warn: 'DA VERIFICARE', unknown: 'NON RICONOSCIUTO' }[lastOutcome] || lastOutcome || '';
        var prod = (CFG.productTitle || HANDLE || '').replace(/\s+/g, ' ').slice(0, 90);
        appendTicket(doc, 'TICKET.content', 'Esito verifica: ' + out + (sv.descr ? ' | Veicolo: ' + sv.descr : '') +
          (v ? ' | Targa/Telaio: ' + v : '') + ' | Prodotto: ' + prod + ' (' + HANDLE + ')');
        appendTicket(doc, 'TICKET.subject', 'Verifica ' + out + (sv.descr ? ' · ' + sv.descr : ''));
        done = !!(ta && v);
      }
    } catch (e) {}
    if (!done && tries < 10) setTimeout(function () { prefillHs(tries + 1); }, 300);
  }
  function showSent() {
    var hs = $('.ctvt__hsform'), sent = $('.ctvt__sent');
    if (hs) hs.style.display = 'none';
    if (sent) sent.style.display = 'block';
    track('lead', { outcome: lastOutcome });
  }
  function loadHsForm() {
    if (root.dataset.hs || !CFG.hsForm) return;
    root.dataset.hs = '1';
    function create() {
      if (!(window.hbspt && window.hbspt.forms)) return;
      window.hbspt.forms.create({
        portalId: CFG.hsPortal, formId: CFG.hsForm, region: CFG.hsRegion || 'na1',
        target: '.ctvt__hsform',
        onFormReady: function () { prefillHs(); },
        onFormSubmitted: showSent
      });
    }
    if (window.hbspt && window.hbspt.forms) return create();
    var s = document.createElement('script');
    s.src = 'https://js.hsforms.net/forms/embed/v2.js';
    s.charset = 'utf-8';
    s.onload = create;
    document.head.appendChild(s);
  }

  /* ---------- verifica ---------- */
  function run(value, kind, opts) {
    opts = opts || {};
    lastValue = value;
    if (!opts.silent) { goBtn.disabled = true; goBtn.textContent = 'Verifico…'; }
    track(opts.silent ? 'autocheck' : 'click', { method: kind });
    return ask(value, kind).then(function (res) {
      var oc = outcomeOf(res);
      lastOutcome = oc;
      var descr = (res && res.vehicle && res.vehicle.descr) || '';
      if (oc === 'ok' || oc === 'warn') { save(value, kind, descr); showChip(descr); }
      // ricontrollo automatico con il servizio non raggiungibile: resta il chip, senza allarmare
      if (opts.silent && res && res.down) return oc;
      if (oc === 'need_vin') setMode('telaio');
      render(oc, res, oc === 'unknown' ? 'not_found' : '', { form: !opts.silent });
      track('result', { outcome: oc, method: kind, silent: !!opts.silent });
      if (!opts.silent) { goBtn.disabled = false; goBtn.textContent = GO_LABEL; }
      return oc;
    });
  }

  /* ---------- wire ---------- */
  function setMode(kind) {
    root.querySelectorAll('.ctvt__tab').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-kind') === kind); });
    var eu = $('.ctvt__eu');
    if (kind === 'telaio') {
      input.maxLength = 17; input.placeholder = 'ZCF… / WJM…'; if (eu) eu.style.display = 'none';
      if (hint) hint.innerHTML = 'Inserisci i 17 caratteri del telaio (riga E del libretto).';
    } else {
      input.maxLength = 17; input.placeholder = 'AB 123 CD'; if (eu) eu.style.display = '';   // 17: chi incolla il telaio nel campo targa viene capito lo stesso
      if (hint) hint.innerHTML = 'Inserisci la targa. Non ce l\'hai? Passa a <b>Telaio</b>.';
    }
    input.value = '';
  }
  if (goBtn) goBtn.addEventListener('click', function () {
    var np = normPlate(input.value);
    var mode = root.querySelector('.ctvt__tab[data-kind="telaio"].is-on') ? 'telaio' : 'targa';
    if (mode === 'telaio') {
      if (!isVin(np)) { var rt = badReason(np, 'telaio'); render('unknown', null, rt); track('badformat', { mode: 'telaio', reason: rt }); return; }
      run(np, 'telaio'); return;
    }
    if (isVin(np)) { run(np, 'telaio'); return; }      // in modo targa ma e' un telaio valido
    if (!isPlate(np)) { var rg = badReason(np, 'targa'); render('unknown', null, rg); track('badformat', { mode: 'targa', reason: rg }); return; }
    run(np, 'targa');
  });
  if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); goBtn.click(); } });
  root.querySelectorAll('.ctvt__tab').forEach(function (t) {
    t.addEventListener('click', function () { setMode(t.getAttribute('data-kind')); try { input.focus(); } catch (e) {} });
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.ctvt__reset')) { e.preventDefault(); resetVehicle(); return; }
    if (e.target.closest('.ctvt__atc')) {
      // stesso "Aggiungi al carrello" della scheda (quantita', popup, Ordine Sicurizzato)
      e.preventDefault();
      track('add_to_cart', {});
      var nativo = document.querySelector('[data-ct-buynow]');
      if (nativo && !nativo.disabled) nativo.click();
      return;
    }
    if (e.target.closest('.ctvt__show-assist')) {
      e.preventDefault();
      assist.classList.add('is-on'); loadHsForm(); prefillHs();
      var more = $('.ctvt__warn-more'); if (more) more.style.display = 'none';
      try { assist.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
    }
  });
  /* ---------- veicolo ricordato finche' il cliente non lo cambia ---------- */
  var saved = readSaved();
  if (saved && saved.value) {
    if (saved.kind === 'telaio') setMode('telaio');
    if (input) input.value = saved.value;
    showChip(saved.descr);
    run(saved.value, saved.kind || 'targa', { silent: true });
  }
})();
